import React, { useState } from 'react'
import CardSelection from './components/CardSelection'
import CustomerRegister from './components/CustomerRegister'
import CustomerSearch from './components/CustomerSearch'

const PolicyOnboarding = () => {
  const [step, setStep] = useState('selection')

  const handleNewCustomer = () => {
    setStep('register')
  }

  const handleExistingCustomer = () => {
    setStep('search')
  }

  const handleBack = () => {
    setStep('selection')
  }

  if (step === 'register') {
    return <CustomerRegister onBack={handleBack} />
  }

  if (step === 'search') {
    return <CustomerSearch onBack={handleBack} />
  }

  return (
    <CardSelection
      onNewCustomer={handleNewCustomer}
      onExistingCustomer={handleExistingCustomer}
    />
  )
}

export default PolicyOnboarding
